
/**
 * Formats a date string (YYYY-MM-DD) to a readable format
 * If the year matches the current year, it displays only the day and month
 * Otherwise, it includes the year
 * 
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Formatted date string (e.g., "9 January" or "9 January 2025")
 */
export const formatAvailableDate = (dateString: string): string => {
    const date = new Date(dateString);
    const currentYear = new Date().getFullYear();
    
    // Format the day and month
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    
    // If it's not the current year, include the year in the output
    if (date.getFullYear() !== currentYear) {
        return `${day} ${month} ${date.getFullYear()}`;
    }
    
    return `${day} ${month}`;
};